import styled from "styled-components";

export const BtnCertificateGenerateWidgetStyled = styled.div`
  .input_wrap {
    margin-bottom: 1rem;
  }
`;
